import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import {MySiteRestService} from '@nuskin/my-site-api'
import template from './my-site-featured-products.html';


export class MySiteFeaturedProducts extends PolymerElement {
    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'my-site-featured-products';
    }

    static get properties() {
        return {
            productDetailPath: {
                type: String,
                value: ''
            },
            featuredProducts: {
                type: Array,
                value: []
            },
            _productSmallTranslations: {
                type: Object,
                value: {}
            },
            featuredProductsTitle: {
                type: String,
                value: ''
            },
            featuredProductsLinkText: {
                type: String,
                value: ''
            },
            featuredProductsDescription: {
                type: String,
                value: ''
            },
            priceType: {
                type: String,
                value: ''
            },
            forMySitePreview: {
                type: Boolean
            }
        }
    }

    async ready() {
        super.ready();
        this.set('basePath', window.location.pathname);
    }

    async connectedCallback() {
        this.subdomain = await MySiteRestService.getCurrentSubdomain()
    }

    _getPdpUrl(sku) {
        return `${this.productDetailPath}.${sku}.mysite.${this.subdomain}.html`;
    }
}

window.customElements.define(MySiteFeaturedProducts.is, MySiteFeaturedProducts);